<template>
    <v-menu v-model="datePickerMenu" :close-on-content-click="false" offset-y>
        <template
            v-slot:activator="{
                on
            }"
        >
            <v-text-field
                v-model="displayDate"
                :label="properties.label"
                :color="properties.color"
                :hint="properties.hint"
                persistent-hint
                readonly
                outlined
                :dense="properties.dense"
                v-on="on"
                prepend-inner-icon="mdi-calendar"
            >
            </v-text-field>
        </template>
        <v-card>
            <v-card-text>
                <v-text-field
                    v-model="date"
                    solo
                    type="date"
                    label="Date"
                    prepend-icon="mdi-calendar"
                    persistent-hint
                    hint="Input the date: MM/DD/YYYY"
                >
                </v-text-field>
                <v-date-picker
                    v-model="date"
                    :color="properties.color"
                    :min="min"
                    :max="max"
                    width="30vw"
                >
                    <slot name="actions"></slot>
                </v-date-picker>
            </v-card-text>
        </v-card>
    </v-menu>
</template>

<script>
/**
 * @name DateMenu
 * @module components/Global/Utils/DateMenu
 *
 * @description
 * A date picker component that can be used to select a date
 * @param {String} model - The v-model of the date picker
 * @param {String} label - The label of the date picker
 * @param {String} hint - The hint of the date picker
 * @param {String} color - The color of the date picker
 * @param {String} min - The minimum date of the date picker
 * @param {String} max - The maximum date of the date picker
 *
 * @example
 * <date-menu
 *  	v-model="date"
 *  	label="Date"
 *  	hint="Select a date"
 *  	color="info"
 *  	min="2021-01-01"
 *  	max="2021-12-31"
 *  />
 */
export default {
    name: 'DateMenu',
    props: {
        properties: {
            type: Object,
            default: () => ({
                label: 'Date',
                hint: 'Select a date',
                color: 'info',
                display: '',
                dense: true
            })
        },
        min: {
            type: String,
            default: new Date(
                new Date().setFullYear(new Date().getFullYear() - 5)
            )
                .toISOString()
                .split('T')[0]
        },
        max: {
            type: String,
            default: new Date(
                new Date().setFullYear(new Date().getFullYear() + 5)
            )
                .toISOString()
                .split('T')[0]
        }
    },
    data() {
        return {
            datePickerMenu: false,
            date: ''
        };
    },
    computed: {
        displayDate() {
            return this.date ? this.date : this.properties.display;
        }
    },
    watch: {
        date(newVal) {
            this.$emit('update:date', newVal);
        }
    }
};
</script>
